import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

export const TagNavigation = ({slug}) => {
    const [SlugData, setSlugData] = useState([]);
    
    useEffect(() => {
        setSlugData(slug.split('-'));
        return () => {
            setSlugData([])
        };
    }, [slug]);

    return (
        <ul className="single_post_tag_layout">
            {
                SlugData && SlugData.map((item, index) => {
                    return (
                        <li key={index}>
                            <Link to="#" rel={item}>{item}</Link>
                        </li>
                    )
                })
            }
        </ul>
    )
};